import JXG from 'jsxgraph'
import evaluatex from 'evaluatex/dist/evaluatex'

const defaultXAxisPoints = [
  [0, 0],
  [1, 0]
]
const defaultYAxisPoints = [
  [0, 0],
  [0, 1]
]

export const createEmptyBoard = (containerId, options) => {
  // Theming reference
  // https://github.com/jsxgraph/jsxgraph/blob/master/src/themes/dark.js
  JXG.Options.axis.strokeColor =
    options?.axisStrokeColor || 'rgba(219, 230, 255, 0.05)'
  JXG.Options.axis.highlightStrokeColor =
    options?.axisStrokeColor || 'rgba(219, 230, 255, 0.05)'
  JXG.Options.axis.ticks.strokeColor = 'rgba(219, 230, 255, 0.03)'
  JXG.Options.axis.ticks.highlightStrokeColor = 'rgba(219, 230, 255, 0.03)'
  JXG.Options.axis.ticks.label.strokeColor = 'rgba(213, 224, 255, 0.3)'
  JXG.Options.axis.ticks.label.highlightStrokeColor = 'rgba(213, 224, 255, 0.3)'
  JXG.Options.curve.strokeColor = '#D764B9'
  JXG.Options.curve.highlightStrokeColor = '#D764B9'

  const board = JXG.JSXGraph.initBoard(containerId, {
    boundingbox: [-5, 5, 5, -5],
    axis: false,
    zoom: {
      factorX: 1.25,
      factorY: 1.25,
      needshift: true
    },
    showCopyright: false
  })

  const xAxis = board.create('axis', defaultXAxisPoints, {
    name: 'x',
    lastArrow: false,
    ticks: {
      strokeOpacity: 1,
      minorTicks: 0,
      label: {
        position: 'rt'
      }
    }
  })

  const yAxis = board.create('axis', defaultYAxisPoints, {
    name: 'y',
    lastArrow: false,
    ticks: {
      strokeOpacity: 1,
      minorTicks: 0,
      label: {
        position: 'rt'
      }
    }
  })

  return { board, axis: { xAxis, yAxis } }
}

export const createFunctionGraph = (board, latex) => {
  try {
    const fn = evaluatex(latex, {}, { latex: true })

    return board.create('functiongraph', [(x) => fn({ x })])
  } catch {
    return null
  }
}
